/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'components/Common/Select';
import FormLabel from '../FormLabel';
import Styles from './index.module.css';

export default function SelectField({
  title,
  description,
  value,
  options,
  onChange,
  disabled,
  required,
  ...props
}) {
  const id = `${title}-${description}-select-field`;
  return (
    <div className={Styles.mainContainer} {...props}>
      <FormLabel
        title={title}
        description={description}
        disabled={disabled}
        required={required}
        htmlFor={id}
      />
      <Select
        id={id}
        value={value}
        options={options}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}

SelectField.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

SelectField.defaultProps = {
  title: '',
  description: '',
  value: '',
  options: [],
  onChange: () => {},
  disabled: false,
  required: false,
};
